import { render, staticRenderFns } from "./BSCreditInvoice.vue?vue&type=template&id=47b10eeb"
import script from "./BSCreditInvoice.vue?vue&type=script&lang=js"
export * from "./BSCreditInvoice.vue?vue&type=script&lang=js"
import style0 from "./BSCreditInvoice.vue?vue&type=style&index=0&id=47b10eeb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports